import {ItemType} from '../../api/memex-items/item-type'
import type {MemexItemModel} from '../../models/memex-item-model'
import type {Row, V7Row} from './types'

export const rowIsExpanded = (row: Row<MemexItemModel>) => {
  if ('isCollapsed' in row) {
    return !row.isCollapsed
  }
  return row.getIsExpanded()
}

export const rowIsGrouped = (row: Row<MemexItemModel>) => {
  if ('isGrouped' in row) {
    return row.isGrouped
  } else if ('getIsGrouped' in row) {
    return row.getIsGrouped()
  }
  return false
}

export const rowIsSelected = (row: Row<MemexItemModel>) => {
  if ('isSelected' in row) {
    return row.isSelected
  } else if ('getIsSelected' in row) {
    return row.getIsSelected()
  }
  return false
}

export const rowToggleSelected = (row: Row<MemexItemModel>, value?: boolean) => {
  if ('toggleRowSelected' in row) {
    row.toggleRowSelected(value)
  } else {
    row.toggleSelected(value)
  }
}

export const rowIsSelectable = (row: Row<MemexItemModel>) => {
  return 'toggleRowSelected' in row || 'toggleSelected' in row
}

export const getAllCells = (row: Row<MemexItemModel>) => {
  if ('cells' in row) {
    return row.cells
  }
  return row.getAllCells()
}

export const isNonRedactedRow = (row: Row<MemexItemModel> | undefined): row is Row<MemexItemModel> => {
  return !!(row && row.original.contentType !== ItemType.RedactedItem)
}

export const isV7Row = (row: Row<MemexItemModel>): row is V7Row => {
  return 'values' in row
}

export const groupingColumnId = (row: Row<MemexItemModel>): string | undefined => {
  if ('groupedColumnId' in row) {
    return row.groupedColumnId
  }
  return row.groupingColumnId
}
